import { useEffect, useState } from "react";
import { OrderContent } from "../../order/OrderList";
import CommonPaginationSection from "../../common/CommonPaginationSection";
import { useInsuranceApi } from "../../../hooks/useInsuranceApi";
import { templateInsuranceOrderData } from "../../../data/order/insurance/insuranceOrdersData";
import SM from "../../DIsplay/Screen/SM";
import InsuranceMenu from "../../order/menu/InsuranceMenu";
import { CancelInsuranceBookingModal } from "../CancelInsuranceBookingModal";
import { CancelPendingInsuranceBookingModal } from "../CancelPendingInsuranceBookingModal";
import { InsuranceOrderDetailsModal } from "../insuranceOrderDetails/InsuranceOrderDetailsModal";
import { PayInsuranceBookingModal } from "../PayInsuranceBookingModal";
import { UpdateFareInsuranceBookingModal } from "../UpdateFareInsuranceBookingModal";
import { ConfirmInsuranceIssuanceModal } from "../ConfirmInsuranceIssuanceModal";
import { RebookInsuranceBookingModal } from "../RebookInsuranceBookingModal";

function CustomerDetailOrdersInsuranceList({ data: accountData }) {
  const { getInsuranceBookings } = useInsuranceApi();
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });

  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);

  const loadData = async () => {
    const res = await getInsuranceBookings(
      {
        limit: pagination.perPage,
        offset: ((pagination.page || 0) - 1) * pagination.perPage,
        account: accountData?._id,
      },
      setLoading
    );
    const [data, total] = res;

    if (total) {
      setPagination({ ...pagination, total });
    }
    if (data) {
      setOgData(data);
      setOrders(
        data?.map((item) => templateInsuranceOrderData(item))
        // ?.map((item) => templateTourOrderTableData(item))
      );
    }
  };

  console.log({ loading });

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  if (loading)
    return (
      <div className="w-full flex items-center justify-center py-6">
        <div className="primaryLoader"></div>
      </div>
    );

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-2 p-1 rounded-md">
        {orders.map((order, index) => (
          <Order
            key={index}
            order={order}
            og={ogData?.at(index)}
            onSuccess={loadData}
          />
        ))}
      </div>
      <CommonPaginationSection
        perPage={pagination.perPage}
        total={pagination.total}
        page={pagination.page}
        callback={(pg, perPage) =>
          setPagination({ ...pagination, page: pg, perPage })
        }
      />
    </div>
  );
}

export default CustomerDetailOrdersInsuranceList;

const Order = ({ order, og, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewInsuranceOrder, setViewInsuranceOrder] = useState(false);
  const [cancelInsuranceOrder, setCancelInsuranceOrder] = useState(false);
  const [cancelPendingInsuranceOrder, setCancelPendingInsuranceOrder] =
    useState(false);
  const [payInsuranceOrder, setPayInsuranceOrder] = useState(false);
  const [updateFareInsuranceOrder, setUpdateFareInsuranceOrder] =
    useState(false);
  const [confirmIssuanceInsuranceOrder, setConfirmIssuanceInsuranceOrder] =
    useState(false);
  const [rebookInsuranceOrder, setRebookInsuranceOrder] = useState(false);
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open) {
        setTimeout(() => {
          setOpen(false);
        }, 400);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="w-full flex  justify-between bg-white p-2 py-4 lg:p-4 gap-3 rounded-md">
      <>
        <CancelInsuranceBookingModal
          open={cancelInsuranceOrder}
          booking={og}
          setOpen={setCancelInsuranceOrder}
          noSave
        />
        <CancelPendingInsuranceBookingModal
          open={cancelPendingInsuranceOrder}
          booking={og}
          setOpen={setCancelPendingInsuranceOrder}
          noSave
        />
        <InsuranceOrderDetailsModal
          open={viewInsuranceOrder}
          booking={og}
          setOpen={setViewInsuranceOrder}
          noSave
        />
        <PayInsuranceBookingModal
          open={payInsuranceOrder}
          booking={og}
          setOpen={setPayInsuranceOrder}
        />
        <UpdateFareInsuranceBookingModal
          open={updateFareInsuranceOrder}
          booking={og}
          setOpen={setUpdateFareInsuranceOrder}
        />
        <ConfirmInsuranceIssuanceModal
          open={confirmIssuanceInsuranceOrder}
          booking={og}
          setOpen={setConfirmIssuanceInsuranceOrder}
        />
        <RebookInsuranceBookingModal
          open={rebookInsuranceOrder}
          booking={og}
          setOpen={setRebookInsuranceOrder}
          onSuccess={onSuccess}
        />
      </>
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full rounded-lg ${width || "flex-1"} ${
              !expand && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              expand && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          //   bookingData?.status || og?.status ? "flex" : "hidden"
          ""
        } flex flex-col justify-between items-center `}
      >
        <button
          className="cursor-pointer p-2 relative "
          disabled={loading}
          onClick={() => setOpen(true)}
        >
          {loading ? (
            <div className="primaryLoader"></div>
          ) : (
            <img
              src="/IconMore.svg"
              alt=""
              className="h-5 object-contain relative"
            />
          )}
          {open && (
            <InsuranceMenu
              order={og}
              // {...{ mobile }}
              setCancelInsuranceOrder={setCancelInsuranceOrder}
              setViewInsuranceOrder={setViewInsuranceOrder}
              setCancelPendingInsuranceOrder={setCancelPendingInsuranceOrder}
              setPayInsuranceOrder={setPayInsuranceOrder}
              setUpdateFareInsuranceOrder={setUpdateFareInsuranceOrder}
              setConfirmIssuanceInsuranceOrder={setConfirmIssuanceInsuranceOrder}
              setRebookInsuranceOrder={setRebookInsuranceOrder}
              setLoading={setLoading}
            />
          )}
          {/* <SM className="">
          </SM> */}
        </button>
        <button
          className="flex lg:hidden"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          <img
            src="/IconChevronDown.svg"
            alt=""
            className={`w-5 object-contain transition-all ${
              expand ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>
    </div>
  );
};
